export default "__VITE_ASSET__7GTIIBxS__"